<template>
    <div class="account-user-info">
        <transition name="account-user-info-fade" mode="out-in">
            <view-user-info v-if="!editInfo" key="view" v-bind="$attrs" edit @edit="editInfo = true" />
            <edit-user-info v-else key="edit" v-bind="$attrs" @save="saveInfo" @cancel="editInfo = false" />
        </transition>
    </div>
</template>

<script>
import EditUserInfo from './edit_user_info'
import ViewUserInfo from './view_user_info'

export default {
    name: `AccountUserInfoRoot`,
    components: {
        EditUserInfo,
        ViewUserInfo
    },
    inheritAttrs: false,
    data: () => ({
        editInfo: false
    }),

    methods: {
        saveInfo(data) {
            this.$emit(`save`, data)
            this.editInfo = false
        }
    }
}
</script>

<style scoped>
.account-user-info {
    min-width: 0;
}
.account-user-info-fade-enter-active,
.account-user-info-fade-leave-active {
    transition: opacity 150ms ease, transform 150ms ease;
}
.account-user-info-fade-enter,
.account-user-info-fade-leave-to {
    opacity: 0;
    transform: translateY(4px);
}
@media (prefers-reduced-motion: reduce) {
    .account-user-info-fade-enter-active,
    .account-user-info-fade-leave-active {
        transition: none;
    }
}
</style>
